import {constructUUID, writeStyleTag} from "./Utils";

export default class Replaceables {

    /**
     * @param {Array} replacements
     * @param {HTMLElement} spreadElement
     * @param {Number} layout
     */
    static replace(replacements, spreadElement, layout) {

        /*
        {
           "data": "Here is a great presentation for you",
           "replacetype":"Replace hele DIV of enkel VAR",
           "varname": "title",
           "type": "text",
           "hideifempty": "1",
           "uuid": "b1829641-60d7-4286-af7c-1f8d83ea2b3e"
         },
        */
        const spread_id = spreadElement.dataset['spread_id'];

        replacements.forEach((replacement) => {
            let element = spreadElement.querySelector(`#${constructUUID(replacement.uuid, layout, spread_id)}`);

            if (!element) {
                return;
            }
            if (!replacement.data) {
                if (replacement.field_empty === "remove") {
                    element.classList.add('empty-replaceable'); // hide the field

                    return
                }
                if (replacement.field_empty === "default") {
                    if (replacement.type === "image") {
                        return
                    }
                    replacement.data = replacement.placeholder || '';
                }
            }

            //Replace part or whole element
            switch (replacement.type) {
                case "text":
                case "richtext":
                case "textarea":
                case "title":
                    if (replacement.replacetype === "part") {
                        element.innerHTML = element.innerHTML.split(replacement.varname).join(replacement.data);
                        // element.innerHTML = element.innerHTML.replace(replacement.varname, replacement.data); // only replaces 1 occurrence
                    } else {
                        element.innerHTML = replacement.data;
                    }
                    break;
                case "image":
                    if (replacement.data) {
                        if (element.nodeName === 'IMG') {
                            element.setAttribute('src', replacement.data)
                        } else {
                            let css = `#spread_${spread_id} #${constructUUID(replacement.uuid, layout, spread_id)}.replaced {background-image: url(${replacement.data})}`;
                            writeStyleTag(css, `replaced_${replacement.uuid}_${layout}`, spreadElement);
                            element.classList.add('replaced');
                        }
                    }
                    break;
            }
        });
    }

    static merge(replaceables = [], default_replaceables = []) {
        let missing_defaults = default_replaceables.filter((default_replacement) => {
            // return default_replacement.uuid === replacement.uuid
            return !replaceables.find((replacement) => {
                return replacement.id === default_replacement.id
            });
        });

        return replaceables.concat(missing_defaults);
    }

    static mergeGlobals(replaceables = [], globals = []) {
        const keys = Object.keys(globals)
        return replaceables.map(replaceable => {
            // if (!replaceable.hasOwnProperty('data')) {
            if (replaceable.data === replaceable.placeholder || (!replaceable.data && replaceable.type === 'image')) {
                if (keys.includes(replaceable.varname)) {
                    replaceable.data = globals[replaceable.varname]
                } else if (keys.includes(replaceable.name)) {
                    replaceable.data = globals[replaceable.name]
                }
            }
            return replaceable
        })
    }
}
